import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

// core components
import Admin from "layouts/Admin.jsx";
import CrmUi from "layouts/CRM.jsx";
import Auth from "layouts/Auth.jsx";
// import RTL from "layouts/RTL.jsx";

import "assets/css/material-dashboard-react.css?v=1.6.0";

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from "redux";
//import thunk from "redux-thunk";
import ReduxReducer from "./store/Reducers/reducer";
//const store = createStore(ReduxReducer, compose(applyMiddleware(thunk)));
const store = createStore(ReduxReducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
//const { store } = ConfigureStore();

const hist = createBrowserHistory();

ReactDOM.render(
  <Provider store={store}>    
    <Router history={hist}>
      <Switch>

        <Route path="/admin" component={Admin} />
        <Route path="/crm" component={CrmUi} />
        <Route path="/auth" component={Auth} />
        {/* <Route path="/rtl" component={RTL} /> */}
        <Redirect from="/:token" exact to="/admin/dashboard?token=:token" />
        <Redirect from="/" exact to="/admin/dashboard" />


      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);
